import React from "react";
import { createPortal } from "react-dom";
import { Modal } from "@tvg/design-system/web";
import type { EnvironmentModalProps } from "../types";
import { DevstackContent } from "./content/devstack";

/**
 * Portalled to the body, and it has to be.
 *
 * The banner is mounted inside the mobile footer, whose container carries
 * `transform: translate3d(0)` and `will-change: transform`
 * (tvg-atomic-ui/_static/BaseComponents/Containers). A transformed ancestor
 * becomes the containing block for every `position: fixed` descendant, so the
 * modal would be laid out against the 48px footer instead of the viewport, and
 * the browser anchors the native select popup off the untransformed box - the
 * options end up a modal height above the field. The portal takes the modal
 * out of that subtree; React context still reaches it through the portal.
 */
export const EnvironmentModal = (props: EnvironmentModalProps) => {
  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      qaLabel="environment-modal"
      headerProps={{
        title: "Environment",
        description: `You're in ${props.env.toUpperCase()}`,
        showCloseButton: true
      }}
    >
      <DevstackContent {...props} />
    </Modal>,
    document.body
  );
};

export default EnvironmentModal;
